export default {
  "app.settings.menuMap.basic": "Basic Settings",
  "app.settings.menuMap.security": "Security Settings",
  "app.settings.menuMap.binding": "Account Binding",
  "app.settings.menuMap.notification": "New Message Notification",
  "app.settings.basic.avatar": "Avatar",
  "app.settings.basic.change-avatar": "Change avatar",
  "app.settings.basic.email": "Email",
  "app.settings.basic.email-message": "Please input your email!",
  "app.settings.basic.nickname": "Nickname",
  "app.settings.basic.nickname-message": "Please input your Nickname!",
  "app.settings.basic.profile": "Personal profile",
  "app.settings.basic.profile-message": "Please input your personal profile!",
  "app.settings.basic.profile-placeholder": "Brief introduction to yourself",
  "app.settings.basic.country": "Country/Region",
  "app.settings.basic.country-message": "Please input your country!",
  "app.settings.basic.geographic": "Province or city",
  "app.settings.basic.geographic-message": "Please input your geographic info!",
  "app.settings.basic.address": "Street Address",
  "app.settings.basic.address-message": "Please input your address!",
  "app.settings.basic.phone": "Phone Number",
  "app.settings.basic.phone-message": "Please input your phone!",
  "app.settings.basic.update": "Update Information",
  "app.settings.security.strong": "Strong",
  "app.settings.security.medium": "Medium",
  "app.settings.security.weak": "Weak",
  "app.settings.security.password": "Account Password",
  "app.settings.security.password-description": "Current password strength",
  "app.settings.security.phone": "Security Phone",
  "app.settings.security.phone-description": "Bound phone",
  "app.settings.security.question": "Security Question",
  "app.settings.security.question-description": "The security question is not set, and the security policy can effectively protect the account security",
  "app.settings.security.email": "Backup Email",
  "app.settings.security.email-description": "Bound Email",
  "app.settings.security.mfa": "MFA Device",
  "app.settings.security.mfa-description": "Unbound MFA device, after binding, can be confirmed twice",
  "app.settings.security.modify": "Modify",
  "app.settings.security.set": "Set",
  "app.settings.security.bind": "Bind",
  "app.settings.binding.taobao": "Binding Taobao",
  "app.settings.binding.taobao-description": "Currently unbound Taobao account",
  "app.settings.binding.alipay": "Binding Alipay",
  "app.settings.binding.alipay-description": "Currently unbound Alipay account",
  "app.settings.binding.dingding": "Binding DingTalk",
  "app.settings.binding.dingding-description": "Currently unbound DingTalk account",
  "app.settings.binding.bind": "Bind",
  "app.settings.notification.password": "Account Password",
  "app.settings.notification.password-description": "Messages from other users will be notified in the form of a station letter",
  "app.settings.notification.messages": "System Messages",
  "app.settings.notification.messages-description": "System messages will be notified in the form of a station letter",
  "app.settings.notification.todo": "To-do Notification",
  "app.settings.notification.todo-description": "The to-do list will be notified in the form of a letter from the station",
  "app.settings.open": "Open",
  "app.settings.close": "Close",
  "app.t0": "The server function resumes its data. ",
  "app.t1": "Data creation or modification is successful.",
  "app.t2": "An enquiry is pending for reply.",
  "app.t3": "Data is deleted successfully. ",
  "app.t4": "There is an error. The server does not create or edit the data. ",
  "app.t5": "User does not have acess (token, username, password incorrect). ",
  "app.t6": "User is authorized, but access is prohibited.",
  "app.t7": "Request is sent for a non-existent record and the server is unable to process the request.",
  "app.t8": "Request method is not granted.",
  "app.t9": "Request format is not available. ",
  "app.t10": "Request for the resources is deleted permanently.",
  "app.t11": "An error occurs during the creation of an customer.",
  "app.t12": "Server is encountering an error, please rectify the error. ",
  "app.t13": "Gateway Error",
  "app.t14": "The service is unavailable, the server undergoing maintenance or overloaded currently. ",
  "app.t15": "Gateway Timeout",
  "app.t16": "Gentle Reminder",
  "app.t17": "Your account login is prohibited, please log in again ~",
  "app.t18": "Gentle Reminder",
  "app.t19": "The page that you visit is no longer available, please visit other sections. ",
  "app.t20": "Gentle Reminder",
  "app.t21": "Fail to create, please try again.",
  "app.t22": "The system is under maintenance, please come back later~",
  "app.t23": "Gentle Reminder",
  "app.t24": "Your network is unable to connect to the server",
  "app.t25": "Network Issues",
  "app.t26": "You do not have permission for this page, if necessary, please contact the administrator to modify",
  "operate.add": "add ",
  "operate.edit": "edit ",
  "operate.view": "view ",
};
